// extracted by mini-css-extract-plugin
export default {"checkout-tips":"checkout-tips--2XpiI","checkout-tips__title":"checkout-tips__title--1nmBE","checkout-tips__form":"checkout-tips__form--3aTI4","checkout-tips__tip-input":"checkout-tips__tip-input--GByin","checkout-tips__tip-input__wrapper":"checkout-tips__tip-input__wrapper--1JF9L","checkout-tips__preview":"checkout-tips__preview--3I6WR","checkout-tips__separator":"checkout-tips__separator--3eTv9","checkout-tips__tip-message":"checkout-tips__tip-message--1MRTt"};
    if(module.hot) {
      // 1744795052793
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  